import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=51ba32a9&scoped=true"
import script from "./UserActivity.vue?vue&type=script&lang=js"
export * from "./UserActivity.vue?vue&type=script&lang=js"
import style0 from "./UserActivity.vue?vue&type=style&index=0&id=51ba32a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba32a9",
  null
  
)

export default component.exports